import { Breadcrumb_Item_default } from "./chunk-QFFN2C46.js";
import { Breadcrumb_default } from "./chunk-DXATRKIP.js";

// src/components/Breadcrumb/index.ts
var BreadcrumbComponent = Breadcrumb_default;
BreadcrumbComponent.Item = Breadcrumb_Item_default;
BreadcrumbComponent.Item.displayName = "Breadcrumb.Item";
export { BreadcrumbComponent };